export default __webpack_public_path__ + "static/avatar-b9971bde8a2b39ea6f72545be9d15129.svg";